export const SHOW_MODAL = "SHOW_MODAL";
export const ADD_THEME_MODAL = "ADD_THEME_MODAL";

export function showModal(data) {
    return {
        type: SHOW_MODAL,
        data
    }
}

export function addThemeModal(data) {
    return {
        type: ADD_THEME_MODAL,
        data
    }
}

